import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class Game extends Phaser.Scene {

  init() {
    this.score = 0;
    this.setHeartScore = 5;

  }

  preload() {
    const fonts = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(fonts);

    this.load.image('ball', new URL('../assets/ball.png', import.meta.url).href);
    this.load.image('bucket', new URL('../assets/bucket.png', import.meta.url).href);
    this.load.image('heart', new URL('../assets/heart.png', import.meta.url).href);

  }

  create() {
    this.physics.world.pause();

    this.time.delayedCall(1000, () => {
      this.physics.world.resume()
    }, [], this)

    console.log('Game working');
    const width = this.scale.width;
    const height = this.scale.height;
    console.log(`width ${width}, height ${height}`);
    this.ballSetVelocity = 500;


    // fall object
    const randomX = Phaser.Math.Between(200, width);
    this.ball = this.physics.add.image(randomX, height / 15, 'ball');
    this.ball.body.setBounce(0, 1);
    this.ball.body.setVelocityY(this.ballSetVelocity);
    this.ball.body.setCollideWorldBounds(true);
    this.ball.setDisplaySize(40, 40)

    this.ball.body.onWorldBounds = true;
    this.physics.world.on('worldbounds', (body) => {

      if (body === this.ball.body) {
        this.setHeartScore -= 1;
        this.hearts[this.setHeartScore].setVisible(false);
        this.resetObj();

        if (this.setHeartScore === 0) {
          this.scene.start('game-over');
        }
        console.log('ball hit wall');
      }
    })

    // bucket
    this.bucket = this.physics.add.image(width / 2, height / 1.05, 'bucket');
    this.bucket.setDisplaySize(90, 90);
    this.bucket.body.setCollideWorldBounds(true, 1, 1);
    this.bucket.body.immovable = true;
    this.physics.add.collider(this.ball, this.bucket, () => {
      this.score += 1;
      this.scoreText.setText(this.score);
      this.resetObj();
      console.log('collide');
    });

    this.cursors = this.input.keyboard.createCursorKeys(); // keyboard input to move the bucket left and right


    // score
    this.scoreText = this.add.text(width / 1.05, height / 15, '0', {
      fontSize: 40,
      fontFamily: "'Press Start 2P'",
    });

    this.hearts = [];
    for (let i = 0; i < 5; i++) {
      const heart = this.add.image(width / 20 + i * 40, height / 15, 'heart');
      heart.setDisplaySize(60, 60);
      this.hearts.push(heart);
    }

  }


  update() {

    const body = this.bucket.body;

    if (this.cursors.left.isDown) {
      body.setVelocityX(-800);
    } else if (this.cursors.right.isDown) {
      body.setVelocityX(800);
    } else {
      body.setVelocity(0)
    }

  }


  // reset the ball after hitting the bucket and the world
  resetObj() {
    const width = this.scale.width
    const randomX = Phaser.Math.Between(50, width);
    this.ball.setPosition(randomX, 50);
    this.ball.body.setVelocityY(this.ballSetVelocity)
  }

}
